import { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import { toast } from "sonner";
import api, { apiError, ROLE_LABELS } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

function formatWaktu(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

const ROLE_BADGE = {
  super_admin: "bg-slate-100 text-slate-700 hover:bg-slate-100",
  kepala_sekolah: "bg-blue-50 text-blue-700 hover:bg-blue-50",
  bendahara: "bg-amber-50 text-amber-700 hover:bg-amber-50",
  orang_tua: "bg-emerald-50 text-emerald-700 hover:bg-emerald-50",
};

export default function ActivityLogs() {
  const { schoolId } = useAuth();
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    api.get("/activity-logs")
      .then((r) => setLogs(r.data))
      .catch((e) => { setLogs([]); toast.error(apiError(e)); });
  }, [schoolId]);

  return (
    <div className="space-y-6" data-testid="activity-logs-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Log Aktivitas</h1>
        <p className="mt-1 text-sm text-slate-500">Jejak semua aksi pengguna untuk keamanan dan audit.</p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-6">
        <div className="overflow-x-auto">
          <Table data-testid="activity-logs-table">
            <TableHeader>
              <TableRow>
                <TableHead>Waktu</TableHead>
                <TableHead>Pengguna</TableHead>
                <TableHead>Peran</TableHead>
                <TableHead>Aktivitas</TableHead>
                <TableHead>Detail</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs === null && (
                <TableRow><TableCell colSpan={5} className="py-8 text-center text-sm text-slate-500">Memuat data...</TableCell></TableRow>
              )}
              {logs !== null && logs.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className="py-10 text-center">
                    <ScrollText className="mx-auto mb-2 h-8 w-8 text-slate-300" strokeWidth={1.5} />
                    <p className="text-sm text-slate-500">Belum ada aktivitas tercatat.</p>
                  </TableCell>
                </TableRow>
              )}
              {(logs || []).map((l) => (
                <TableRow key={l.id} className="transition-colors duration-200 hover:bg-slate-50" data-testid={`log-row-${l.id}`}>
                  <TableCell className="whitespace-nowrap text-sm text-slate-600">{formatWaktu(l.created_at)}</TableCell>
                  <TableCell className="text-sm font-medium text-slate-800">{l.user_name}</TableCell>
                  <TableCell>
                    <Badge className={`rounded-full ${ROLE_BADGE[l.role] || ""}`}>{ROLE_LABELS[l.role] || l.role}</Badge>
                  </TableCell>
                  <TableCell className="text-sm font-medium text-slate-700">{l.action}</TableCell>
                  <TableCell className="text-sm text-slate-600">{l.detail}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
